import CMC from './cmc';
import MC2 from './mc2';
import LS from './ls';

const { BRICATA_APPLIANCE_TYPE } = process.env;
const routes = BRICATA_APPLIANCE_TYPE === 'cmc' ? CMC : BRICATA_APPLIANCE_TYPE === 'mc2' ? MC2 : LS;

export default routes;
